import isEmpty from 'lodash/isEmpty';

import { SEARCH_RESULT_TYPES } from '@lumapps/search/constants';
import { SEARCH_SOURCE_TYPES } from '@lumapps/search/keys/sourceTypes';
import { BaseSearchResult, CommunitySearchResult } from '@lumapps/search/types';
import { addBaseSlugToSearchUrl } from '@lumapps/search/utils';

import { props as breadcrumbProps } from '../Breadcrumb/props';
import { CommunityResultProps } from './types';

const props = (result: BaseSearchResult, baseProps: any, options: any): CommunityResultProps => {
    const { instanceId, translateKey, translate } = options;
    const { name, snippet, onClick, flag, quickViewUrl, onQuickViewClick, tagz } = baseProps;
    const { community } = result as { community: CommunitySearchResult };
    const { instanceDetails } = community;

    /** Check that instance name is available to avoid displaying empty value */
    const hasInstanceName = Object.values(instanceDetails.name).some((value) => !isEmpty(value));

    const breadcrumbLevels = breadcrumbProps({
        instance: hasInstanceName ? instanceDetails : undefined,
        metadata: community.metadataDetails,
        translate,
    });

    return {
        name,
        snippet,
        flag,
        quickViewUrl,
        onQuickViewClick,
        tagz,
        thumbnail: community.thumbnail,
        shouldOpenInNewTab: instanceId !== instanceDetails.id,
        url: addBaseSlugToSearchUrl(community.url),
        onClick,
        position: result.position,
        id: community.uid,
        iconName: 'google-circles-extended',
        kind: translateKey(SEARCH_SOURCE_TYPES.COMMUNITY),
        privacy: community.privacy,
        type: SEARCH_RESULT_TYPES.COMMUNITY,
        breadcrumbLevels,
    };
};

export { props };
